import styled from 'styled-components';

// language=SCSS prefix=*{ suffix=}
export const MainStyled = styled.main`
    flex-grow: 1;
`;
